export const STATUS_UPLOAD_CSV: App.OptionsFnc = (t) => [
  { label: t('master_registration.status_immediate_reflection'), value: '01' },
  {
    label: t('master_registration.status_reservation_reflection'),
    value: '02',
  },
];
